<div class="ccb-root"
	 [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

	<p-toast></p-toast>

	<div class="ccb-shell">
		<div class="ccb-kpi-row">
			<div class="ccb-kpi-card" *ngFor="let card of kpiCards">
				<div class="ccb-kpi-card__inner">
					<div class="ccb-kpi-card__head">
						<span class="ccb-kpi-card__title">{{ card.title }}</span>
						<i class="ccb-kpi-card__icon" [ngClass]="card.icon"></i>
					</div>
					<p class="ccb-kpi-card__value">{{ card.value }}</p>
					<p class="ccb-kpi-card__hint">{{ card.hint }}</p>
				</div>
			</div>
		</div>

		<div class="ccb-card">
			<div class="ccb-card__table">
				<div class="ccb-card__body">
					<div class="ccb-table-wrap">
						<p-table [value]="bookings"
								 [lazy]="true"
								 (onLazyLoad)="onBookingsTableLazyLoad($event)"
								 [paginator]="true"
								 [(first)]="first"
								 [rows]="rows"
								 [totalRecords]="totalRecords"
								 [loading]="loading"
								 [scrollable]="true"
								 [scrollHeight]="tableBodyScrollHeight"
								 [showCurrentPageReport]="true"
								 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
								 paginatorStyleClass="paginator-left ccb-paginator"
								 [rowsPerPageOptions]="[10, 25, 50]"
								 [tableStyle]="{ 'min-width': tableMinWidth }"
								 styleClass="ccb-slot-table p-datatable-sm"
								 dataKey="Id"
								 selectionMode="single"
								 [(selection)]="selectedOrder"
								 (onRowSelect)="onRowSelect($event.data)">
							<ng-template pTemplate="caption">
								<div class="ccb-table-caption">
									<div class="ccb-table-caption__rule"></div>
									<div class="ccb-table-caption__bar">
										<div class="ccb-table-caption__title-wrap">
											<h2 class="ccb-table-caption__title">Bookings</h2>
										</div>
										<div class="ccb-table-caption__actions">
											<button type="button"
													*ngIf="canCreateWalkInBooking && stats.ShowConnexService"
													pButton
													class="ccb-action-btn ccb-action-btn--primary"
													label="Walk-in Booking"
													icon="pi pi-plus"
													(click)="openWalkInBooking()"></button>
											<column-selector #columnSelector
															 class="ccb-column-selector"
															 [btnHeight]="36"
															 [defaultColumns]="defaultCols"
															 [tableName]="tableName"
															 [(selectedColumns)]="cols"
															 (selectedColumnsChange)="onSelectedColumnsChange($event)">
											</column-selector>
										</div>
									</div>
									<div class="ccb-table-caption__rule"></div>
								</div>
							</ng-template>

							<ng-template pTemplate="header">
								<tr>
									<th *ngFor="let col of cols"
										[pSortableColumn]="col.field"
										[pSortableColumnDisabled]="col.disableSort"
										class="ccb-th"
										[class.ccb-th--no-sort]="col.disableSort">
										<div class="ccb-th__inner">
											<span>{{ col.header }}</span>
											<p-sortIcon *ngIf="!col.disableSort" [field]="col.field" />
										</div>
									</th>
								</tr>
								<tr class="ccb-filter-row">
									<ng-container *ngFor="let col of cols">
										<th class="overflow-unset">
											<ng-container *ngIf="col.fieldType === fieldTypeEnum.Inputs">
												<input type="text"
													   pInputText
													   class="w-full"
													   [placeholder]="col.placeholder"
													   [(ngModel)]="headerSearch[col.model]"
													   (input)="handleFilterChange(col.field, $event)" />
											</ng-container>
											<ng-container *ngIf="col.fieldType === fieldTypeEnum.InputNumber">
												<p-inputNumber inputId="integeronly"
															   class="w-full"
															   [placeholder]="col.placeholder"
															   [(ngModel)]="headerSearch[col.model]"
															   (ngModelChange)="handleFilterChange(col.field, $event)"></p-inputNumber>
											</ng-container>
											<ng-container *ngIf="col.fieldType === fieldTypeEnum.Dropdown">
												<ng-container *ngIf="col.take === 'obj'; else valueDropdown">
													<p-dropdown [options]="getDropdownOptions(col)"
																class="w-full"
																[placeholder]="col.placeholder"
																[optionLabel]="col.optionLabel || 'name'"
																[showClear]="true"
																[(ngModel)]="headerSearch[col.model]"
																(ngModelChange)="onChangeHeaderFilterDropDown(col.field, $event)"></p-dropdown>
												</ng-container>
												<ng-template #valueDropdown>
													<p-dropdown [options]="getDropdownOptions(col)"
																class="w-full"
																[placeholder]="col.placeholder"
																[optionLabel]="col.optionLabel || 'name'"
																[optionValue]="col.optionValue || 'value'"
																[showClear]="true"
																[(ngModel)]="headerSearch[col.model]"
																(ngModelChange)="onChangeHeaderFilterDropDown(col.field, $event)"></p-dropdown>
												</ng-template>
											</ng-container>
											<ng-container *ngIf="col.fieldType === fieldTypeEnum.Calendar">
												<p-calendar [(ngModel)]="headerSearch[col.model]"
															class="w-full"
															[showIcon]="true"
															[placeholder]="col.placeholder"
															dateFormat="dd M yy"
															(ngModelChange)="onChangeHeaderFilterDropDown(col.field, $event)" />
											</ng-container>
										</th>
									</ng-container>
								</tr>
							</ng-template>

							<ng-template pTemplate="body" let-row>
								<tr [pSelectableRow]="row" class="ccb-data-row">
									<td *ngFor="let col of cols">
										<ng-container [ngSwitch]="col.field">
											<ng-container *ngSwitchCase="'Id'">
												<span class="ccb-td-text">{{ formatBookingId(row.Id) }}</span>
											</ng-container>
											<ng-container *ngSwitchCase="'StatusText'">
												<span class="ccb-status-pill"
													  [ngStyle]="getStatusStyles(row)">{{ row.StatusText }}</span>
											</ng-container>
											<ng-container *ngSwitchCase="'PickupLocation'">
												<span class="ccb-td-text ccb-td-ellipsis"
													  [title]="row.PickupLocation">{{ row.PickupLocation || '—' }}</span>
											</ng-container>
											<ng-container *ngSwitchCase="'DropOffLocation'">
												<span class="ccb-td-text ccb-td-ellipsis"
													  [title]="row.DropOffLocation">{{ row.DropOffLocation || '—' }}</span>
											</ng-container>
											<ng-container *ngSwitchCase="'ScheduledAt'">
												<span class="ccb-td-text">{{ row.ScheduledAtDate || '—' }}</span>
											</ng-container>
											<ng-container *ngSwitchCase="'CreatedAt'">
												<span class="ccb-td-text">{{ row.Date || '—' }}</span>
											</ng-container>
											<ng-container *ngSwitchCase="'PaxCount'">
												<span class="ccb-td-text">{{ paxLabel(row.PaxCount) }}</span>
											</ng-container>
											<ng-container *ngSwitchCase="'Reason'">
												<span class="ccb-td-text">{{ row.Reason || '—' }}</span>
											</ng-container>
											<ng-container *ngSwitchCase="'VehicleTypeId'">
												<span class="ccb-td-text">{{ row.VehicleTypeText || '—' }}</span>
											</ng-container>
											<ng-container *ngSwitchCase="'SourceText'">
												<span class="ccb-td-text">{{ row.SourceText || '—' }}</span>
											</ng-container>
											<ng-container *ngSwitchCase="'Amount'">
												<span class="ccb-td-text ccb-td--money">{{ fareLabel(row.Amount) }}</span>
											</ng-container>
											<ng-container *ngSwitchDefault>
												<span class="ccb-td-text">{{ row[col.field] || '—' }}</span>
											</ng-container>
										</ng-container>
									</td>
								</tr>
							</ng-template>
						</p-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<booking-details-sidebar [isOpen]="sidebarOpen"
						 [orderId]="selectedOrder?.Id || 0"
						 headerIcon="directions_bus"
						 [visibleTabs]="bookingDetailVisibleTabs"
						 (closed)="onSidebarClose()"
						 (cancelTrip)="onCancelTrip($event)"
						 (completeTrip)="onCompleteTrip($event)"
						 (forceAssign)="onForceAssign($event)"
						 (prioritizeRequest)="onPrioritizeRequest($event)">
</booking-details-sidebar>

<force-assign-dialog [(visible)]="forceAssignDialogVisible"
					 [loading]="forceAssignLoading"
					 [drivers]="nearbyDrivers"
					 [isConnex]="forceAssignIsConnex"
					 [orderId]="forceAssignOrderId"
					 (assignSuccess)="onDriverAssigned()">
</force-assign-dialog>

<connex-walk-in-booking-drawer #walkInDrawer
							   [connexZoneOptions]="connexZoneOptions"
							   (created)="onWalkInBookingCreated()"></connex-walk-in-booking-drawer>
